import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {OrderFilesList} from './OrderFilesList';
import ModalContainer from '../../../../_common/components/ModalContainer';
import ModalContent from '../../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../../_common/components/ModalButtonsContainer';
import ButtonAction from '../../../../_common/components/ButtonAction';
import ModalHeader from '../../../../_common/components/ModalHeader';
import {buttonCancel} from '../../../../_common/styles/styles';

interface PopupSelectOrderFileProps {
  label: string,
  orderID: number,
  fileTypeID: number,
  shumaID: number,
}

const PopupSelectOrderFile = ({
                                label,
                                orderID,
                                fileTypeID,
                                shumaID
                              }: PopupSelectOrderFileProps) => {
  const [open, setOpen] = useState(false);
  const handleOpenPopup = () => setOpen(true);
  const handleClosePopup = () => setOpen(false);
  const {formatMessage} = useIntl();
  const prefix = 'inspection-details-page-dropdown-file';

  return (
    <>
      <div className={'w-100'} onClick={handleOpenPopup}>
        <img
          src={'../../../media/common/File-plus.svg'}
          alt="file" className={'d-inline-block'}
        />
        <div className="text-dark mr-4 ml-1 d-inline-block">
          {formatMessage({id: `${prefix}-${label}`, defaultMessage: 'File'})}
        </div>
      </div>
      <ModalContainer show={open} onHide={handleClosePopup} size={'lg'}>
        <>
          <ModalHeader
            header={formatMessage({id: `${prefix}-${label}`, defaultMessage: 'File'})}
            type={'complex'}
            icon={'/media/common/Upload_file.svg'}
          />
          <ModalContent>
            <OrderFilesList
              fileTypeID={fileTypeID}
              orderID={orderID}
              shumaID={shumaID}
              closePopup={handleClosePopup}
            />
          </ModalContent>
          <ModalButtonsContainer>
            <ButtonAction
              variant={'cancel'}
              label={'ביטול'}
              onClick={handleClosePopup}
              disabled={false}
              customClassnames={buttonCancel}
            />
          </ModalButtonsContainer>
        </>
      </ModalContainer>
    </>
  );
};

export default PopupSelectOrderFile;